module.exports = wx;


//////////////////
// WEBPACK FOOTER
// external "wx"
// module id = 44
// module chunks = 0